import { isLaufzeitVariante, realZuChartX } from "./zeitachse.js"

function chartSettings(data) {
	return data?.charteinstellungen || {}
}

function hiddenSeries(data) {
	const hs = chartSettings(data)?.hidden_series
	return Array.isArray(hs) ? hs.map(String) : []
}

function visibleBySettings(data, id, defaultVisible = true) {
	return hiddenSeries(data).includes(String(id)) ? false : defaultVisible
}

function transformSerieData(data, values = []) {
	if (!isLaufzeitVariante(data)) return values

	return values.map(([utcMs, value]) => [realZuChartX(utcMs, data), value])
}

function approximationForSeries(id) {
	switch (id) {
		case "verbindlichkeit":
		case "tilgungssurrogat_wert":
			return function (values) {
				return Array.isArray(values) && values.length > 0 ? values[values.length - 1] : null
			}
		case "sondertilgungspotential":
			return "high"
		default:
			return "sum"
	}
}

function dataGroupingFor(data, id, existing = {}) {
	if (!isLaufzeitVariante(data)) return existing

	return {
		...existing,
		approximation: approximationForSeries(id),
	}
}

export function seriesLiqui(data) {
	return [
		{
			name: "Verbindlichkeit",
			id: "verbindlichkeit",
			legendName: "Verbindlichkeit",
			legendIndex: 1,
			yAxis: 0,
			type: "area",
			zIndex: 0,
			visible: visibleBySettings(data, "verbindlichkeit", true),
			color: farbeVerbindlichkeiten,
			dataGrouping: dataGroupingFor(data, "verbindlichkeit"),
			data: transformSerieData(data, data.endschulden),
		},
		{
			name: "Zins",
			id: "zins",
			legendName: "Zins",
			legendIndex: 2,
			yAxis: 1,
			type: "column",
			color: farbeZinsen,
			zIndex: 2,
			index: 4,
			visible: visibleBySettings(data, "zins", true),
			dataGrouping: dataGroupingFor(data, "zins"),
			data: transformSerieData(data, data.zinsen),
		},
		{
			name: "Tilgung",
			id: "tilgung",
			legendName: "Tilgung",
			legendIndex: 3,
			yAxis: 1,
			type: "column",
			color: farbeTilgung,
			zIndex: 2,
			index: 3,
			visible: visibleBySettings(data, "tilgung", true),
			dataGrouping: dataGroupingFor(data, "tilgung"),
			data: transformSerieData(data, data.tilgungen),
		},
		{
			name: "Sondertilgungspotential",
			id: "sondertilgungspotential",
			legendName: "Sondertilgungspotential",
			legendIndex: 5,
			yAxis: 1,
			type: "column",
			dataGrouping: dataGroupingFor(data, "sondertilgungspotential", {
				approximation: "high",
			}),
			cursor: "pointer",
			point: {
				events: {
					click: function () {
						data.onSondertilgungspotentialClick?.({
							zeitpunktUtcMs: isLaufzeitVariante(data) ? data.chartXZuReal?.(this.x) || this.x : this.x,
							kreditId: data.kreditId,
						})
					},
				},
			},
			color: farbeSondertilgungspotential,
			zIndex: 2,
			index: 1,
			visible: visibleBySettings(data, "sondertilgungspotential", true),
			data: transformSerieData(data, data.sondertilgungspotentiale),
		},
		{
			name: "Sondertilgung",
			id: "sondertilgung",
			legendName: "Sondertilgung",
			legendIndex: 4,
			yAxis: 1,
			type: "column",
			color: farbeSondertilgungen,
			zIndex: 2,
			index: 2,
			visible: visibleBySettings(data, "sondertilgung", true),
			dataGrouping: dataGroupingFor(data, "sondertilgung"),
			data: transformSerieData(data, data.sondertilgungsbetraege),
		},
		{
			name: "Tilgungssurrogat Wert",
			id: "tilgungssurrogat_wert",
			legendName: "Tilgungssurrogat",
			legendIndex: 6,
			yAxis: 0,
			type: "area",
			zIndex: -1,
			color: farbeTilgungssurrogat,
			visible: visibleBySettings(data, "tilgungssurrogat_wert", true),
			dataGrouping: dataGroupingFor(data, "tilgungssurrogat_wert"),
			data: transformSerieData(data, data.tilgungssurrogatBruttowerte),
		},
		{
			name: "Vorfälligkeit",
			id: "vfe",
			legendName: "Vorfälligkeit",
			legendIndex: 7,
			yAxis: 1,
			type: "column",
			color: farbeZulagen,
			zIndex: 2,
			visible: visibleBySettings(data, "vfe", true),
			dataGrouping: dataGroupingFor(data, "vfe"),
			data: transformSerieData(data, data.vfeen),
		},
	]
}
